import React from 'react'
import { useGlobalState } from '~/store/hooks'

import Views from '~/components/Views'
import Connectivity from '~/components/dialogs/Connectivity'
import Login from '~/components/dialogs/Login'
import Outdated from '~/components/dialogs/Outdated'
import Web3 from '~/components/dialogs/Web3'
import Invited from '~/components/dialogs/Invited'
import PlayError from '~/components/dialogs/PlayError'
import InputApp from '~/components/partials/InputApp'
import InfoDev from '~/components/partials/InfoDev'

export default function View() {
    const [{ outdated }] = useGlobalState('outdated')

    if (outdated !== null) {
        return <Outdated />
    }

    return (
        <>
            {/* <InfoDev /> */}
            <Views />
            <Web3 />
            <Invited />
            <PlayError />
            <Login />
            <Connectivity />
            <InputApp />
        </>
    )
}
